var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgToggle = function SvgToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.056 34.5H13.95c-5.88 0-10.554-4.65-10.554-10.5S8.07 13.5 13.95 13.5h21.107c5.88 0 10.554 4.65 10.554 10.5s-4.674 10.5-10.554 10.5Z",
    stroke: "#fff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.949 30c3.33 0 6.03-2.686 6.03-6s-2.7-6-6.03-6-6.03 2.686-6.03 6 2.7 6 6.03 6Z",
    stroke: "#fff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgToggle;